import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

import { CategoryAutocomplete } from '#components/autocomplete/CategoryAutocomplete';

type JevCategoryPickerProps = {
  onSelect: (categoryId: string) => void;
  onCancel: () => void;
};

// Lets the user give a category of their own; the JEV takes it as an example
// for similar transactions.
export function JevCategoryPicker({
  onSelect,
  onCancel,
}: JevCategoryPickerProps) {
  const { t } = useTranslation();

  return (
    <View style={{ gap: 6, flexShrink: 0 }}>
      <View
        style={{
          flexDirection: 'row',
          gap: 10,
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <View style={{ flex: 1 }}>
          <CategoryAutocomplete
            value={null}
            showSplitOption={false}
            inputProps={{
              autoFocus: true,
              placeholder: t('Select category...'),
            }}
            onSelect={id => {
              if (id) {
                onSelect(id);
              }
            }}
          />
        </View>
        <Button variant="bare" onPress={onCancel}>
          <Trans>Cancel</Trans>
        </Button>
      </View>
      <Text style={{ color: theme.pageTextSubdued, fontSize: 12 }}>
        <Trans>
          The JEV will use your choice as an example for similar transactions.
        </Trans>
      </Text>
    </View>
  );
}
